var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33963 0C2.40462 0 0.830308 1.57425 0.830308 3.50932V5.51359C0.830308 5.53636 0.802202 5.57474 0.780123 5.58208C0.59035 5.64536 0.436228 5.7002 0.295144 5.75459C0.126897 5.81945 0 6.0059 0 6.18832V10.7936C0 10.9747 0.126078 11.1613 0.293258 11.2276C1.58677 11.7402 2.94816 12 4.33961 12C5.73106 12 7.09245 11.7401 8.38602 11.2275C8.55314 11.1613 8.67916 10.9747 8.67916 10.7936V6.18832C8.67916 6.0059 8.55228 5.81945 8.38395 5.75453C8.24281 5.70014 8.08871 5.6453 7.89908 5.58202C7.87706 5.57468 7.84895 5.53628 7.84895 5.5135V3.50926C7.84885 1.57425 6.27464 0 4.33963 0ZM3.38378 7.59091C3.38378 7.06264 3.81172 6.63514 4.33957 6.63514C4.86737 6.63514 5.29532 7.0626 5.29532 7.59091C5.29532 7.94096 5.09792 8.23403 4.81743 8.40017V9.98036C4.81743 10.2445 4.6037 10.4582 4.33955 10.4582C4.07538 10.4582 3.86166 10.2445 3.86166 9.98036V8.40017C3.5812 8.23403 3.38378 7.94096 3.38378 7.59091ZM6.64226 3.50926V5.23857C5.8856 5.07597 5.11387 4.9939 4.33994 4.99374C3.56581 4.99396 2.79386 5.07597 2.03696 5.23839V3.50926C2.03696 2.23957 3.0699 1.20665 4.33957 1.20665C5.60922 1.20663 6.64226 2.23957 6.64226 3.50926Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtected);
export default __webpack_public_path__ + "static/media/Protected.64d3456fa820a7a5c333f6f6dc3f4869.svg";
export { ForwardRef as ReactComponent };